import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationInterfaceEnum, Parameter } from '@features/applications/interfaces/action.interface';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';

@Pipe({
  name: 'addChildAllowed',
  standalone: true,
})
export class AddChildAllowedPipe implements PipeTransform {
  public transform(field: FormlyFieldConfig, options: FormlyFormOptions, triggered = 0): boolean {
    const value: Parameter = field?.form?.value || field?.model;
    const valueTypeProperty = options.formState?.valueTypeProperty || 'type';
    const valueDataTypeProperty = options.formState?.valueDataTypeProperty || 'data_type';

    switch (options.formState.interface) {
      case ApplicationInterfaceEnum.SOAP:
      case ApplicationInterfaceEnum.XML:
        return ['body', 'soap_header', 'header', 'fault'].includes(value?.[valueTypeProperty]);
      default:
        return ['array', 'object'].includes(value?.[valueDataTypeProperty]);
    }
  }
}
